import type { IconSvgObject } from './types';

const ArrowLeftDoubleIcon: IconSvgObject = [
  ["path", { d: "M11.5 6L5.5 12L11.5 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.5 6L12.5 12L18.5 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowLeftDoubleIcon;
